<app-loader [loading]="loading"></app-loader>
@if (districtMapping) {
    <div class="flex flex-col gap-3">
        <div class="flex gap-2 items-center">
            <p-button icon="pi pi-arrow-left"
                      routerLink="/districts"
                      [outlined]="true">
            </p-button>
            <span>Back to Districts</span>
        </div>
        <h3 class="m-0">{{ districtMapping.mapped_district.district ?? districtMapping.district_name | valueOr }}</h3>
        <div class="flex gap-4">
            <span><strong>State: </strong>{{ districtMapping.mapped_district.state | valueOr }}</span>
            <span><strong>County: </strong>{{ districtMapping.mapped_district.county | valueOr }}</span>
            <span><strong>Address: </strong>{{ districtMapping.mapped_district.address | valueOr }}</span>
        </div>
        <span><strong>Agenda Platform: </strong>{{ districtMapping.mapped_district.agenda_platform | valueOr }}</span>
        <div class="flex gap-3 items-center">
            <strong>Source:</strong>
            @if (editingLinkMode) {
                <input pInputText [(ngModel)]="editingLink" class="w-full"/>
                <p-button icon="pi pi-check"
                          size="small"
                          severity="secondary"
                          [rounded]="true"
                          (onClick)="editDistrict()">
                </p-button>
                <p-button icon="pi pi-times"
                          size="small"
                          severity="secondary"
                          [rounded]="true"
                          (onClick)="editingLinkMode = false">
                </p-button>
            } @else {
                @if (districtMapping.mapped_district.agenda_url) {
                    <a [href]="districtMapping.mapped_district.agenda_url"
                       target="_blank">{{ districtMapping.mapped_district.agenda_url | valueOr }}</a>
                } @else {
                    {{ districtMapping.mapped_district.agenda_url | valueOr }}
                }
                <p-button icon="pi pi-pencil"
                          size="small"
                          severity="secondary"
                          [rounded]="true"
                          (onClick)="openEditMode()">
                </p-button>
            }
        </div>
        <p-tabs [(value)]="activeTabLabel">
            <p-tablist>
                @for (tab of tabs; track tab.label) {
                    <p-tab [value]="tab.label" class="flex items-center !gap-2 text-inherit">
                        <i [class]="tab.icon"></i>
                        <span>{{ tab.label }}</span>
                    </p-tab>
                }
            </p-tablist>
            <div class="mt-3">
                @if (activeTab?.type) {
                    <app-district-document-listing [type]="activeTab?.type">
                    </app-district-document-listing>
                } @else {
                    <app-rate-listing [groupBy]="activeTab?.groupBy"
                                      [title]="activeTab?.label"
                                      [preset]="activeTab?.preset">
                    </app-rate-listing>
                }
            </div>
        </p-tabs>
    </div>
}
